import React, {useContext, useEffect, useState} from "react";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export default function NavigationCardFloor({id, code, title, clickFunction}){
	
	const [percentage, setPercentage] = useState(0);
	
	useEffect(() => {
		setPercentage(Math.round(Math.random()*100));
	}, [id]);
	
	const thisContainer = {
			display:'flex',
			backgroundColor:"white",
			width:"200px",
			boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
			borderRadius:"5px",
			margin:"10px",
			flexDirection:"column",
			cursor:"pointer"
	};
	
	
	const codeContainer = {
		display:"flex",
		marginTop:"20px",
		alignSelf:"center",
		fontColor:COLOR_GRAY_BANNER_BACKGROUND,
		fontSize:"36px"
	};
	
	const titleContainer = {
		display:"flex",
		margin:"10px",
		alignSelf:"center",
		fontColor:COLOR_GRAY_BANNER_BACKGROUND,
		fontSize:"14px"
	};
	
	const percentageNumber = {
		display:'flex',
		width:"100px",
		height:"30px",
		borderRadius:"5px",
		marginRight:"10px",
		//backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		backgroundColor:"#eee",
		alignItems:"center",
		justifyContent:"space-around",
		marginLeft:"calc(50% - 50px)",
		fontSize:"14px",
		color:COLOR_GRAY_BANNER_BACKGROUND,
		fontWeight:"bold",
		marginBottom:"10px"
	};
	
	const percentageHolder = {
		display:"flex",
		width:"calc(100% - 20px)",
		marginBottom:"10px",
		marginLeft:"10px",
		//backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		backgroundColor:"#eee",
		alignItems:"center",
		borderTopLeftRadius:"5px",
		borderBottomLeftRadius:"5px",
		height:"10px",
		borderBottomRightRadius:"5px"
	};
	
	const percentageIndicatorHolder = {
		display:"flex",
		width:"100%"
	};
	
	const percentageIndicator = {
		display:"flex",
		width:percentage +"%",
		backgroundColor:"#1DDBD5",
		height:"10px",
		borderRadius:"5px",
		opacity:"0.6"
	};
	
	const handleClick = () => {
		clickFunction(id);
	}
	
	return (
		<div style={thisContainer} onClick={handleClick}>
				<div style={codeContainer}>
					{code}
				</div>
				<div style={titleContainer}>
					{title}
				</div>
				
		</div>
	);
}